import React from 'react';
import Navbar from '../components/Navbar';
import './Registry.css';

const Registry = () => {
    return (
        <div>
            <Navbar />
            <section className="registry section">
                <div className="registry-container">
                    <hr className="divider" /> {/* Top Divider */}
                    <h1 className="section-title">Registry</h1>
                    <div className="registry-content">
                        <p>
                            Your presence at our wedding is the greatest gift of all! However, if you wish to contribute to our honeymoon fund, we would be forever grateful as we embark on this new adventure together.
                        </p>
                        <div className="registry-links">
                            <button
                                onClick={() => window.open("https://www.honeyfund.com/site/timandseneca", "_blank", "noopener,noreferrer")}
                                className="registry-button"
                            >
                                Contribute to our honeymoon!
                            </button>
                        </div>
                    </div>
                    <hr className="divider" /> {/* Bottom Divider */}
                </div>
            </section>
        </div>
    );
};

export default Registry;
